export function pluckHexValues(value) {
  const [r, g, b] = value.toUpperCase().match(/[0-9A-F]{2}/g);
  return { r, g, b };
}
export function pluckHexValuesAsDecimal(value) {
  const { r, g, b } = pluckHexValues(value);

  return {
    r: convertToDecimal(r),
    g: convertToDecimal(g),
    b: convertToDecimal(b),
  };
}

export const convertToDecimal = (value) => parseInt(value, 16);

export const convertToHexadecimal = (value) => {
  let hexVal = value.toString(16);

  // For values less than 16, prepend a `0`.
  // From 'E' to '0E':
  if (value < 16) {
    hexVal = `0${hexVal}`;
  }

  // For values like "EE" or "55", the format flattens it to a
  // single value, "E" and "5". Double it back up:
  if (hexVal.length === 1) {
    hexVal = `${hexVal}${hexVal}`;
  }

  return hexVal;
};
